import "./Wrapper.css";

const Wrapper = ({ children }) => {
  return <div className="calculator">{children}</div>;
};

export default Wrapper;